import { ShoppingCart } from 'lucide-react';
import SEOHead from '@/components/SEOHead';

const DistanceSalesPage = () => {
  return (
    <div className="min-h-screen bg-slate-50">
      <SEOHead
        title="Mesafeli Satış Sözleşmesi | TesisKirala.com"
        description="TesisKirala.com Mesafeli Satış Sözleşmesi. Online rezervasyon işlemlerinde geçerli sözleşme koşulları."
        canonicalPath="/mesafeli-satis-sozlesmesi"
      />
      
      {/* Hero */}
      <section className="bg-emerald-800 py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-16 h-16 bg-emerald-700 rounded-2xl flex items-center justify-center mx-auto mb-6">
            <ShoppingCart className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-3xl md:text-4xl font-extrabold text-white mb-4">
            Mesafeli Satış Sözleşmesi
          </h1>
          <p className="text-emerald-100">
            Son güncelleme: Aralık 2024
          </p>
        </div>
      </section>

      {/* Content */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12 prose prose-slate max-w-none">
            
            <h2>MADDE 1 - TARAFLAR</h2>
            
            <h3>1.1. SATICI</h3>
            <table className="w-full border-collapse">
              <tbody>
                <tr>
                  <td className="font-medium w-40">Unvan:</td>
                  <td>AVRASYA SPORTİF FAALİYETLER</td>
                </tr>
                <tr>
                  <td className="font-medium">Adres:</td>
                  <td>Altıntepe Mah. Galipbey Cad. Dış Kapı No: 119/A Dükkân No: 2 Esen Apt., Maltepe/İSTANBUL</td>
                </tr>
                <tr>
                  <td className="font-medium">Telefon:</td>
                  <td>+90 505 368 60 91</td>
                </tr>
                <tr>
                  <td className="font-medium">E-posta:</td>
                  <td>tesiskirala@gmail.com</td>
                </tr>
              </tbody>
            </table>

            <h3>1.2. ALICI</h3>
            <p>
              İşbu sözleşmeyi kabul ederek rezervasyon yapan kullanıcı.
            </p>

            <h2>MADDE 2 - KONU</h2>
            <p>
              İşbu sözleşmenin konusu, ALICI'nın SATICI'ya ait tesiskirala.com internet sitesinden 
              elektronik ortamda sipariş verdiği aşağıda nitelikleri ve satış fiyatı belirtilen 
              hizmetin satışı ve teslimi ile ilgili olarak 6502 sayılı Tüketicinin Korunması Hakkındaki 
              Kanun ve Mesafeli Sözleşmeler Yönetmeliği hükümleri gereğince tarafların hak ve 
              yükümlülüklerinin belirlenmesidir.
            </p>

            <h2>MADDE 3 - HİZMET BİLGİLERİ</h2>
            <p>
              Hizmetin temel özellikleri (türü, süresi, kullanım koşulları vb.) SATICI'ya ait 
              internet sitesinde yer almaktadır. Hizmetin temel özelliklerini kampanya süresince 
              inceleyebilirsiniz. Kampanya tarihine kadar geçerlidir.
            </p>
            <ul>
              <li><strong>Hizmet Türü:</strong> Spor tesisi kiralama (rezervasyon)</li>
              <li><strong>Ödeme Şekli:</strong> Kredi kartı / Banka kartı</li>
              <li><strong>Teslimat:</strong> Dijital onay (e-posta ve SMS)</li>
            </ul>

            <h2>MADDE 4 - GENEL HÜKÜMLER</h2>
            <p>
              4.1. ALICI, tesiskirala.com internet sitesinde sözleşme konusu hizmetin temel 
              nitelikleri, satış fiyatı ve ödeme şekli ile teslimata ilişkin ön bilgileri 
              okuyup bilgi sahibi olduğunu ve elektronik ortamda gerekli teyidi verdiğini beyan eder.
            </p>
            <p>
              4.2. Hizmet, ALICI'nın seçtiği tarih ve saatte kullanıma sunulacaktır.
            </p>
            <p>
              4.3. Sözleşme konusu hizmet, yasal 30 günlük süreyi aşmamak koşulu ile her bir 
              hizmet için ALICI'nın yerleşim yerinin uzaklığına bağlı olarak internet sitesinde 
              ön bilgiler içinde açıklanan süre içinde ALICI'ya sunulur.
            </p>

            <h2>MADDE 5 - CAYMA HAKKI</h2>
            <p>
              5.1. ALICI, sözleşme konusu hizmetin kendisine sunulmasından itibaren 14 (on dört) 
              gün içinde herhangi bir gerekçe göstermeksizin ve cezai şart ödemeksizin sözleşmeden 
              cayma hakkına sahiptir.
            </p>
            <p>
              5.2. <strong>Önemli:</strong> Mesafeli Sözleşmeler Yönetmeliği'nin 15. maddesi gereğince, 
              belirli bir tarihte veya dönemde yapılması gereken hizmetlerde (spor tesisi rezervasyonu gibi), 
              hizmetin ifa edilmeye başlaması ile cayma hakkı sona erer.
            </p>
            <p>
              5.3. Rezervasyon tarihi geçtikten sonra cayma hakkı kullanılamaz.
            </p>

            <h2>MADDE 6 - İPTAL ve İADE KOŞULLARI</h2>
            <table className="w-full border-collapse border border-slate-200">
              <thead>
                <tr className="bg-slate-50">
                  <th className="border border-slate-200 p-3 text-left">İptal Zamanı</th>
                  <th className="border border-slate-200 p-3 text-left">İade Oranı</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td className="border border-slate-200 p-3">Rezervasyondan 24 saat öncesine kadar</td>
                  <td className="border border-slate-200 p-3 text-green-600 font-medium">%100 iade</td>
                </tr>
                <tr>
                  <td className="border border-slate-200 p-3">Rezervasyondan 24 saat içinde</td>
                  <td className="border border-slate-200 p-3 text-red-600 font-medium">İade yok</td>
                </tr>
                <tr>
                  <td className="border border-slate-200 p-3">Tesis kaynaklı iptal</td>
                  <td className="border border-slate-200 p-3 text-green-600 font-medium">%100 iade</td>
                </tr>
              </tbody>
            </table>

            <h2>MADDE 7 - ÖDEME ve TESLİMAT</h2>
            <p>
              7.1. Ödeme, kredi kartı veya banka kartı ile online olarak yapılır.
            </p>
            <p>
              7.2. Ödeme tamamlandığında, rezervasyon onayı ALICI'nın e-posta adresine ve 
              telefon numarasına gönderilir.
            </p>
            <p>
              7.3. ALICI, rezervasyon kodunu tesise giriş sırasında ibraz etmekle yükümlüdür.
            </p>

            <h2>MADDE 8 - TEMERRÜT HALİ ve HUKUKİ SONUÇLARI</h2>
            <p>
              ALICI'nın, kredi kartı ile yapmış olduğu işlemlerde temerrüde düşmesi halinde 
              kart sahibi bankanın kendisi ile yapmış olduğu kredi kartı sözleşmesi çerçevesinde 
              faiz ödeyecek ve bankaya karşı sorumlu olacaktır.
            </p>

            <h2>MADDE 9 - YETKİLİ MAHKEME</h2>
            <p>
              İşbu sözleşmenin uygulanmasında, Gümrük ve Ticaret Bakanlığınca ilan edilen değere 
              kadar Tüketici Hakem Heyetleri ile ALICI'nın veya SATICI'nın yerleşim yerindeki 
              Tüketici Mahkemeleri yetkilidir.
            </p>

            <h2>MADDE 10 - YÜRÜRLÜK</h2>
            <p>
              ALICI, site üzerinden rezervasyon işlemini tamamladığında işbu sözleşmenin tüm 
              koşullarını kabul etmiş sayılır. SATICI, siparişin gerçekleşmesi öncesinde işbu 
              sözleşmenin sitede ALICI tarafından okunup kabul edildiğine dair onay alacak şekilde 
              gerekli yazılımsal düzenlemeleri yapar.
            </p>

            <div className="bg-slate-50 border border-slate-200 rounded-lg p-4 mt-8">
              <p className="mb-0 text-sm text-slate-600">
                <strong>SATICI:</strong> AVRASYA SPORTİF FAALİYETLER<br />
                <strong>ALICI:</strong> [Rezervasyon yapan kullanıcı]<br />
                <strong>TARİH:</strong> [Rezervasyon tarihi]
              </p>
            </div>

          </div>
        </div>
      </section>
    </div>
  );
};

export default DistanceSalesPage;
